<template>
  <v-date-picker
      class="table-rangeInput"
      v-model="item.values"
      is-range
      :locale="lang().locale"
      :firstDayOfWeek="2"
      :masks="lang().korean ? {
        title: 'YYYY년 MMMM',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss.sssZ', 'YYYY/MM/DD'],
        dayPopover: 'L',
        } : {}"
      :popover="{
        placement: item.componentOptions ? item.componentOptions.popoverDirection : popoverDirection,
        visibility: item.componentOptions ? item.componentOptions.popoverVisibility : popoverVisibility,
      }"
  >
    <template v-slot="{ inputValue, inputEvents }">
      <div class="popover-container">
        <input
            :placeholder="lang().korean ? `YYYY.MM.DD ~ YYYY.MM.DD` : `MM/DD/YYYY ~ MM/DD/YYYY`"
            readonly
            :value="inputValue.start !== null && inputValue.end !== null ? `${inputValue.start} ~ ${inputValue.end}` : ''"
            v-on="inputEvents.start"
            style="min-width: 150px"
        />
      </div>
    </template>
  </v-date-picker>
</template>
<script>
    export default {
      props: ['item'],
      data() {
        return {
          popoverDirection: 'top',
          popoverVisibility: 'hover',
          lang: () => {
            const language = navigator?.language || navigator?.userLanguage;
            const currentLang = localStorage.getItem('lang') ?? language;
            const korean = currentLang.includes('ko');
            const chinese = currentLang.includes('zh');
            const czech = currentLang.includes('cs');
            let locale = 'en'

            if (korean)
              locale = 'ko';
            // TODO: 중국어 운영 배포시 URL 체크 삭제
            else if (!window.location.href.includes('https://manager.rebless.clinic') && chinese)
              locale = 'zh-hk';
            // TODO: 체코어 운영 배포시 URL 체크 삭제
            else if (!window.location.href.includes('https://manager.rebless.clinic') && czech)
              locale = 'cs';

            return {
              korean: korean,
              locale: locale,
            }
          }
        }
      }
    }
</script>
<style lang="scss">
.popover-container {
  input {
    width: 100%;
    text-align: center;
    text-indent: 0;
    font-size: 12px;
  }
}

.table-rangeInput {
  input:focus {
    border: 1px solid var(--blue70);
  }

  input:disabled {
    background-color: var(--grey10) !important;
  }
}
</style>